'use client';

import { Chip } from '@coolblue-development/freddy';
import { Euro } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';
import { SalaryRange, SalaryValue } from '@sharedTypes';

type Props = {
  salaryValue?: SalaryValue;
  salaryRange?: SalaryRange;
};

export const SalaryChip = ({ salaryValue, salaryRange }: Props) => {
  const { t } = useTranslation('vacancyDetail.header');

  let translatedSalary;

  if (salaryValue) {
    translatedSalary = `${salaryValue.value} ${t(`salary.${salaryValue.rate}`)}`;
  }

  if (salaryRange) {
    translatedSalary = `${t('salary.range', {
      min: salaryRange.min,
      max: salaryRange.max
    })} ${t(`salary.${salaryRange.rate}`)}`;
  }

  if (!translatedSalary) {
    return <></>;
  }

  return <Chip startIcon={<Euro />}>{translatedSalary}</Chip>;
};
